import { render } from "./AccountSettingGeneral.vue?vue&type=template&id=52102c18"
import script from "./AccountSettingGeneral.vue?vue&type=script&lang=js"
export * from "./AccountSettingGeneral.vue?vue&type=script&lang=js"
script.render = render

export default script